// extracted by mini-css-extract-plugin
module.exports = {"component":"_Oy7Otzg08UJovDBrnQyt","isThemeLight":"_2GKWPahWaMPUHhaDOXA7lG","isThemeDark":"_2s2EAyz1ukOLbSuQbA0CGx","isSimpleLink":"w68ktr6ZFvMk99IpiskhR"};